var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.listaIndicadores,"item-value":"id","item-text":"nombre","solo":"","hide-details":"","label":_vm.textoSelector},on:{"change":_vm.indicadorSeleccionado}})
}
var staticRenderFns = []

export { render, staticRenderFns }